import type { ActivationFlowDefinition } from "../types";

export const firstExportTranscriptFlow: ActivationFlowDefinition = {
    id: "first_export_transcript",
    title: "First Export Transcript Workflow",
    steps: [
        {
            id: "intro_editor",
            title: "Welcome to the editor",
            target: "[data-tour='editor-workspace-area']",
            placement: "center",
            spotlightPadding: 14,
            content:
                "In this quick demo, we'll edit your episode by editing the transcript.",
            advance: {
                type: "manual",
            },
        },
        {
            id: "delete_transcript_section",
            title: "Delete a section",
            target: "[data-tour='transcript-panel']",
            placement: "right",
            spotlightPadding: 12,
            content:
                "This is your transcript. Highlight a section and press Delete to remove it. Or click strikethrough on the toolbar.",
            advance: {
                type: "condition",
                condition: "script_has_cut",
            },
        },
        {
            id: "open_ai_tools",
            title: "Open AI Tools",
            target: "[data-tour='sidebar-ai-tools-button']",
            placement: "left",
            content:
                "Open AI Tools to access transcript cleanup actions.",
            advance: {
                type: "click",
                selector: "[data-tour='sidebar-ai-tools-button']",
            },
        },
        {
            id: "open_filler_tool",
            title: "Open filler cleanup",
            target: "[data-tour='ai-tools-remove-filler']",
            placement: "left",
            content:
                "Click Remove filler words to open the cleanup toolbar.",
            advance: {
                type: "click",
                selector: "[data-tour='ai-tools-remove-filler']",
            },
            autoAdvanceDelayMs: 500,
        },
        {
            id: "choose_filler_selection",
            title: "Choose what to remove",
            target: "[data-tour='filler-filter-select']",
            placement: "bottom",
            content:
                "Click Select to choose which filler categories to remove.",
            preStepAction: "activate_filler_words",
            advance: {
                type: "click",
                selector: "[data-tour='filler-filter-select']",
            },
            autoAdvanceDelayMs: 500,
        },
        {
            id: "remove_filler_words",
            title: "Remove filler words",
            target: "[data-tour='filler-remove-all']",
            placement: "bottom",
            content:
                "Remove filler words automatically. Click Remove all to clean up 'um', 'uh', and repeated phrases.",
            preStepAction: "activate_filler_words",
            advance: {
                type: "click",
                selector: "[data-tour='filler-remove-all']",
            },
            autoAdvanceDelayMs: 900,
        },
        {
            id: "tighten_long_pauses",
            title: "Tighten long pauses",
            target: "[data-tour='gap-shorten-all']",
            placement: "bottom",
            content:
                "Tighten long pauses. Click Shorten all for a tighter flow.",
            preStepAction: "activate_gap_removal",
            advance: {
                type: "click",
                selector: "[data-tour='gap-shorten-all']",
            },
            autoAdvanceDelayMs: 900,
        },
        {
            id: "restore_last_edit",
            title: "Restore a cut",
            target: "[data-tour='editor-undo-button']",
            placement: "bottom",
            content:
                "Changed your mind? Click Undo to instantly restore your last edit.",
            advance: {
                type: "click",
                selector: "[data-tour='editor-undo-button']",
            },
        },
        {
            id: "generate_chapters",
            title: "Generate chapters",
            target: "[data-tour='chapters-generate']",
            placement: "left",
            content:
                "Organize your episode with chapters. Click Generate to create chapter suggestions.",
            preStepAction: "open_add_chapters_sidebar",
            advance: {
                type: "click",
                selector: "[data-tour='chapters-generate']",
            },
            autoAdvanceDelayMs: 700,
        },
        {
            id: "apply_chapters",
            title: "Add chapters to script",
            target: "[data-tour='chapters-apply']",
            placement: "left",
            content:
                "Great. Click Add to script to insert these chapters into your transcript.",
            preStepAction: "open_add_chapters_sidebar",
            advance: {
                type: "click",
                selector: "[data-tour='chapters-apply']",
            },
        },
        {
            id: "open_export_menu",
            title: "Export your composition",
            target: "[data-tour='editor-export-button']",
            placement: "bottom",
            content: "Click Export to open export settings.",
            advance: {
                type: "click",
                selector: "[data-tour='editor-export-button']",
            },
        },
        {
            id: "start_export",
            title: "Start export",
            target: "[data-tour='export-card-submit']",
            placement: "left",
            content: "Click Export to render your first episode.",
            advance: {
                type: "click",
                selector: "[data-tour='export-card-submit']",
            },
        },
    ],
};
